import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getCookie, getInlineLoader } from "../Helpers";
import { MdFavorite, MdInfo, MdPhoneAndroid } from "react-icons/md";

export default function DonationForm(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);

  const [amount, setAmount] = useState("");
  const [payPhone, setPayPhone] = useState("");

  async function init() {
    setReady(false);
    //..
    setReady(true);
  }

  async function submit() {
    const userId = getCookie("userId");

    if (!userId) {
      appContext.tellError("Session expired, please login again");
      return;
    }

    if (!isNaN(amount) && Number(amount) > 0) {
      if (String(payPhone).trim().length >= 9) {

        setLoading(true);
        await callApi(
          "create-donation",
          {
            userId,
            amount: Number(amount),
            payPhone: `255${parseInt(payPhone, 10)}`,
          }
        ).then((response) => {
          if (response.status === 1) {
            appContext.tellMessage("Thank you for your donation!");
            appContext.navBack();
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError("Invalid payment phone number");
      }
    } else {
      appContext.tellError("Invalid amount");
    }
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);

    return () => {
      appContext.setShowOverlayLoader(false);
    }
  }, [loading])

  if (ready) {
    return (
      <div className="container" style={{ paddingBottom: "40px" }}>
        <div className="row">

          <div className="col-md-12">
            <h6 className="main-section-title" style={{ marginBottom: "18px" }}>
              Donation
            </h6>
          </div>

          <div className="col-md-12">
            <div
              className="mShadow3"
              style={{
                borderRadius: "26px",
                background: "rgba(244,244,244,0.80)",
                backdropFilter: "blur(14px)",
                WebkitBackdropFilter: "blur(14px)",
                border: "1px solid rgba(0,0,0,0.06)",
                overflow: "hidden",
              }}
            >

              <div style={{ padding: "18px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "4px",
                    borderRadius: "10px",
                    background: "linear-gradient(90deg, var(--primaryColor), var(--secondaryColor))",
                    marginBottom: "14px",
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    marginBottom: "6px",
                  }}
                >
                  <div
                    className="mShadow1"
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "14px",
                      background: "rgba(255,255,255,0.6)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid rgba(0,0,0,0.06)",
                    }}
                  >
                    <MdFavorite className="text-primary" size={20} />
                  </div>

                  <div>
                    <h6 className="mNoMargin font-semi-bold" style={{ fontSize: "16px" }}>
                      Give with joy
                    </h6>
                    <p className="mNoMargin font-regular" style={{ fontSize: "12px", opacity: 0.7 }}>
                      Enter amount and the phone to charge
                    </p>
                  </div>
                </div>
              </div>

              <div style={{ padding: "18px", paddingTop: "0px" }}>
                <div className="row">

                  <div className="col-md-12 mt-2 mb-2">
                    <label className="form-label">Amount</label>
                    <input
                      className="form-control"
                      value={amount}
                      onChange={(e) => setAmount(_prev => {
                        if (Number(e.target.value)) {
                          return Number(e.target.value);
                        } else if (String(e.target.value).trim().length === 0) {
                          return "";
                        } else {
                          return _prev;
                        }
                      })}
                      placeholder="e.g. 5000"
                      style={{
                        borderRadius: "18px",
                        paddingTop: "12px",
                        paddingBottom: "12px",
                        fontSize: "16px",
                      }}
                    />
                    <div className="form-text" style={{ opacity: 0.8 }}>
                      Enter any amount you wish to give
                    </div>
                  </div>

                  <div className="col-md-12 mt-2 mb-2">
                    <label className="form-label">Payment Phone</label>

                    <div className="input-group">
                      <span
                        className="input-group-text font-semi-bold text-secondary"
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        +255
                      </span>
                      <input
                        className="form-control"
                        value={payPhone}
                        onChange={(e) => setPayPhone(_prev => {
                          if (Number(e.target.value)) {
                            return Number(e.target.value);
                          } else if (String(e.target.value).trim().length === 0) {
                            return "";
                          } else {
                            return _prev;
                          }
                        })}
                        maxLength={10}
                        placeholder="XXX XXX XXX"
                        type="text"
                        style={{
                          fontSize: "16px",
                        }}
                      />
                    </div>

                    <div className="form-text" style={{ opacity: 0.8 }}>
                      Phone number used to complete payment
                    </div>
                  </div>

                  <div className="col-md-12 mt-3 mb-2">
                    <button
                      className="btn btn-padded btn-block btn-primary btn-rounded"
                      //onClick={submit}
                    >
                      Donate Now
                    </button>
                  </div>

                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }

}
